import {createProjectModel} from 'crm/utils/project-model'
import {
    contactWayMaterialsExport,
    updateContactWayMaterialsSettings,
    contactWayMaterialsSettings,
} from './service'

const model = createProjectModel({
    projectNamespace: 'drainageContactMeExportMaterial',
    state: {},
    effects: {
        *contactWayMaterialsSettings(_, {call}) {
            return yield call(contactWayMaterialsSettings)
        },
        *contactWayMaterialsExport({payload}, {call}) {
            return yield call(contactWayMaterialsExport, payload)
        },
        *updateContactWayMaterialsSettings({payload}, {call}) {
            return yield call(updateContactWayMaterialsSettings, payload)
        },
    },
    reducers: {},
})

export default model
